import styled from '@emotion/styled';
import { ButtonLink } from '@kyruus/button';
import { fromTheme } from '@kyruus/ui-theme';
import { BREAKPOINTS } from '../../lib/constants';

export const StyledWaitTimeSection = styled.section`
  padding: ${fromTheme('spacing_medium')};
  background: ${fromTheme('color_background')};
  border-width: ${(props) =>
    fromTheme('provider_profile_border_width')(props) ||
    fromTheme('border_width')(props)};
  border-style: ${fromTheme('provider_profile_border_style')};
  border-color: ${fromTheme('provider_profile_color_border')};
  border-radius: ${fromTheme('provider_profile_border_radius')};
  box-shadow: ${fromTheme('provider_profile_box_shadow')};

  @media screen and (min-width: ${BREAKPOINTS.large}px) {
    margin-bottom: ${fromTheme('spacing_large')};
  }
`;

export const StyledWaitTimeHeader = styled('h2')`
  margin: 0 0 ${fromTheme('spacing_small')} 0;
  font-size: ${fromTheme('font_size_heading_4')};
  font-weight: ${fromTheme('font_weight_bolder')};
  color: ${fromTheme('color_text')};
  line-height: ${fromTheme('font_line_height')};
`;

export const StyledWaitTime = styled('h3')`
  font-size: ${fromTheme('font_size_heading_2')};
  font-weight: ${fromTheme('font_weight')};
  color: ${fromTheme('color_text')};
  margin: 0;
  line-height: ${fromTheme('font_line_height')};
  padding: ${fromTheme('spacing_xsmall')} 0;
`;

export const StyledLocation = styled('ul')`
  list-style: none;
  padding: 0;
  margin: ${fromTheme('spacing_small')} 0 0 0;

  li:nth-child(2) span {
    color: ${fromTheme('color_text')};
    font-weight: ${fromTheme('font_weight')};
  }
`;

export const StyledLocationName = styled('li')`
  color: ${fromTheme('color_text')};
  font-weight: ${fromTheme('font_weight_bold')};
  font-size: ${fromTheme('font_size')};
`;

export const StyledButtonLink = styled(ButtonLink)`
  text-align: center;
  box-sizing: border-box;
  width: 100%;
  margin: ${fromTheme('spacing_large')} 0;
`;

export const StyledLoader = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${fromTheme('spacing_small')};
  margin-bottom: ${fromTheme('spacing_large')};
`;
